import React from 'react';
import classNames from 'classnames';

import './ClaimsTable.scss';

function ClaimsTable(props) {
  const { children, showDorStatus } = props;
  return <table styleName={classNames('claims-table', { 'without-dor-column': !showDorStatus })}>{children}</table>;
}

export default ClaimsTable;
